/**
 * Equipment names as a reader should see them. Mirrors pv_core/labels.py:
 * the catalogue appends housekeeping tokens to a record's name ("… correct
 * sandia" says which parameter set it was corrected to); they are stripped
 * from the end of the name only, as whole words.
 */
const CATALOG_SUFFIX_TOKENS = new Set(["correct", "corrected", "sandia", "cec", "pvwatts", "fixed", "fix", "v2", "copy"]);

export function displayName(name) {
  const text = String(name || "").replace(/\s+/g, " ").trim();
  if (!text) return "—";
  const words = text.split(" ");
  while (words.length > 1 && CATALOG_SUFFIX_TOKENS.has(words[words.length - 1].toLowerCase().replace(/[()[\]]/g, ""))) {
    words.pop();
  }
  return words.join(" ");
}
